import { render, staticRenderFns } from "./PlayerEdit.vue?vue&type=template&id=7f5b5c2d&"
import script from "./PlayerEdit.vue?vue&type=script&lang=js&"
export * from "./PlayerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports